<template>
  <div class="loading" :style="{ '--icon-size': size }">
    <div :style="getFillStyle(0)"></div>
    <div :style="getFillStyle(0.3)"></div>
    <div :style="getFillStyle(0.6)"></div>
  </div>
</template>

<script setup>
const props = defineProps({
  fillColor: {
    type: String,
    default: 'var(--primary)',
  },
  size: {
    type: String,
    default: '1.5rem', // Default size if not provided
  },
});

const getFillStyle = (delay) => ({
  background: props.fillColor.includes('gradient')
    ? props.fillColor
    : props.fillColor,
  animationDelay: `${delay}s`,
});
</script>

<style scoped>
.loading {
  gap: calc(var(--icon-size) / 6);
  width: var(--icon-size);
  height: var(--icon-size);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading div {
  width: calc(var(--icon-size) / 6);
  height: calc(var(--icon-size) / 6);
  margin: var(--gap) calc(var(--gap) * 1.5);
  background: v-bind(fillColor); /* fillColor prop as background */
  border-radius: 50%;
  animation: bounce 0.9s infinite alternate;
  animation-delay: var(--delay);
  background-size: 200%;
}

@keyframes bounce {
  to {
    opacity: 0.3;
    transform: translateY(calc(var(--icon-size) / -8));
  }
}
</style>
